<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col justify="center" lg="6">
        <h2>The APD Council</h2>
        <p></p>
        <v-img contain height="100px" src="../../assets/bestiole.gif"></v-img>
        <p></p>
        <p><b>APD co-chairs: </b> Anne-Marie Lézine, Sarah Ivory</p>
        <p>
          <b>EPD liaison: </b>Michelle Leydet (EPD data manager)/Graciela Gil
          Romera
        </p>
        <p>
          <b>Data stewards: </b>Jemma Finch, Lynne Quick, Estelle Razanatsoa,
          Chris Kiahtipes, Will Gosling, Adele Julier, Alejandra Domic, Rahab
          Kinyanjui, Esther Githumbi, Michele Diniès, Ilham Bouimetarhan,
          Graciela Gil-Romera
        </p></v-col
      ></v-row
    >
  </v-container>
</template>

<script>
export default {};
</script>

<style>
a:link {
  color: #2b2118;
}
a:visited {
  color: #2b2118;
}
</style>